// extracted by mini-css-extract-plugin
module.exports = {"infoLabelStyling":"info-label_infoLabelStyling_1MbzD"};